import { useState } from "react";
import { ChevronDown, Download } from "lucide-react";
import { onboarding } from "@/features/onboarding/api/onboarding.api";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { toastApiError } from "@/lib/toast";

export default function ExportLinksMenu() {
  const [busy, setBusy] = useState(false);

  async function run(format: "csv" | "xlsx") {
    setBusy(true);
    try {
      await onboarding.exportLinks(format);
    } catch (e) {
      toastApiError(e, "Export failed.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" variant="outline" size="sm" disabled={busy}>
          <Download />
          {busy ? "Exporting…" : "Export"}
          <ChevronDown />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={() => run("csv")}>CSV (.csv)</DropdownMenuItem>
        <DropdownMenuItem onSelect={() => run("xlsx")}>Excel (.xlsx)</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
